module.exports = __webpack_public_path__ + "static/media/35_B.5e0df97a.png";